const excelTemplate = {
  vehicleBulkImport: "/file/upload/template/车辆批量导入模版.xlsx",
  batchUpdateLicensePlate: "/file/upload/template/批量更新车牌号.xlsx",
  powerBatteryInformation: "/file/upload/template/动力电池信息批量导入.xlsx",
  faultCode: "file/upload/template/Fault_code_import_template.xlsx",
  terminalCodeOld: "/file/upload/template/TerminalCodeOld.xlsx",
  terminalCode: "file/upload/template/TerminalCode.xlsx",
  error: {
    noExcel: "上传格式不正确，请上传xls或者xlsx格式"
  }
} 
export default excelTemplate